export default __webpack_public_path__ + "static/media/nis.3a11d176.png";